<div class="content-poster position-relative">
  <img [src]="posterUrl()" [alt]="title()" [style.height]="posterHeight" [style.width]="posterWidth"/>

  <div class="content-time-info position-absolute w-100">
    <div class="content-time" [class.live]="isLive()">
      <ng-container *ngIf="isLive()">
        <gray-icon style="width: 18px;" class="me-1" icon="stream"></gray-icon>
        {{'live_stream.live'|translate}}
      </ng-container>

      <ng-container *ngIf="!isLive() && duration()">
        {{duration()|timeFormat}}
      </ng-container>

      <ng-container *ngIf="!isLive() && !duration() && liveStream?.status === streamStatus.Published && liveStream?.bePublishedAt">
        {{liveStream?.bePublishedAt|liveStreamDate}}
      </ng-container>
    </div>

    <ngb-progressbar *ngIf="watchedPercent()" [value]="watchedPercent()"/>
  </div>
</div>
